import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/media";

export default function NewsBulletin({ items }: { items: NewsItem[] }) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <i className="ri-newspaper-line text-lg text-secondary-500"></i>
          <h2 className="font-heading text-base font-bold text-foreground-900">影视资讯快讯</h2>
        </div>
        <Link
          to="/news"
          className="flex items-center gap-0.5 whitespace-nowrap text-xs text-secondary-600 transition-colors hover:text-secondary-700"
        >
          全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <ul className="space-y-4">
        {items.map((news) => (
          <li key={news.id}>
            <Link to={`/news/detail/${news.id}`} className="group block">
              <p className="line-clamp-2 text-sm font-medium leading-snug text-foreground-800 transition-colors group-hover:text-secondary-600">
                {news.title}
              </p>
              <p className="mt-1 flex items-center gap-2 text-xs text-foreground-400">
                <span className="rounded bg-accent-50 px-1.5 py-0.5 text-accent-700">
                  {news.category}
                </span>
                <span>{news.date}</span>
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}